import {createContext} from 'react'

const ConsultaCompraProductoContext = createContext()

export default ConsultaCompraProductoContext